¯<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="tableItems"
            item-key="serial"
            :items-per-page="20" 
            :footer-props="{
                'items-per-page-options' : [20, 40, -1]
            }"
            dense
            class="elevation-5"
        >

            <!-- Columns -->
            <template v-slot:item.average0="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"> {{ item.average0 }} </span>
                    </template>
                    <span>{{ item.tooltip0 }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.average1="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"> {{ item.average1 }} </span>
                    </template>
                    <span>{{ item.tooltip1 }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.average2="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"> {{ item.average2 }} </span>
                    </template>
                    <span>{{ item.tooltip2 }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.average3="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"> {{ item.average3 }} </span>
                    </template>
                    <span>{{ item.tooltip3 }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.average4="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"> {{ item.average4 }} </span>
                    </template>
                    <span>{{ item.tooltip4 }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.average5="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"> {{ item.average5 }} </span>
                    </template>
                    <span>{{ item.tooltip5 }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.average6="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"> {{ item.average6 }} </span>
                    </template>
                    <span>{{ item.tooltip6 }}</span>
                </v-tooltip>
            </template>

            <!-- Date Selection Toolbar -->
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>
                        {{ accountTitle }}
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="showPreviousDate">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>

                    <v-btn icon @click="showToday">
                        <v-icon>mdi-calendar-today</v-icon>
                    </v-btn>

                    <v-toolbar-title>
                        {{ localDate }}
                    </v-toolbar-title>

                    <v-btn icon @click="showNextDate">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="downloadCsv">
                        <v-icon>mdi-download-circle-outline</v-icon>
                    </v-btn>
                </v-toolbar>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { API, Hub } from 'aws-amplify';
import { listLastSensorUnixTimes } from '@/graphql/queries';

import {
    compareSensorsByName,
    pingAccount,
    dayjs,
    peek,
} from '@/tools';
peek; // lint

import { text } from '@/language';

import { getSensorDayReading, listSensorCheckoutRecordsByAccountByDate } from '@/graphql/queries';

const Papa = require( 'papaparse' );

import { ascend, chain, map, pipe, prop, sortWith } from 'ramda';

function formatCheckoutRecordDate( checkoutRecord, unixtimeSelector ) {
    if ( ! checkoutRecord[ unixtimeSelector ] )
        return '';

    const checkout = dayjs.unix( checkoutRecord[ unixtimeSelector ] );

    return checkout.format( 'HH:mm' );
}

export default {
    name: 'AverageTemperatureView',

    async created() {
        this.globalState = this.$root.$data.globalState;
        Hub.listen( 'monitor', data => {
            if ( ['ev:setAccount', 'ev:changeDate'].includes( data.payload.event ) )
                this.showAccount();
        } );
    },

    mounted() {
        this.showAccount();
    },

    data: () => ({

        globalState : {},

        checkoutType : {
            delivery : { label : 'Salida',  value : 'En Ruta' },
            repairs  : { label : 'Taller',  value : 'Taller' },
            extra    : { label : 'Extra',   value : 'Extra' },
            resting  : { label : 'Inmóvil', value : 'Inmóvil' },
            checkin  : { label : 'Llegada', value : 'Llegada' }, // not really a checkout type
        },

        accountTitle : '',

        tableItems : [
            // { name : 'foo', '2020-10-12' : 'aja' },
        ],

        formattedLastCheckUnixtime : '?',

        accountDevicesCache : {
            loginId : '',
            devices : [],
        },
    }),

    computed : {
        localDate() {
            return this.globalState.localDate();
        },

        headers() {
            const dayHeaders = this.currentWeekDates().map( date => (
                {
                    text : date.format( 'ddd D' ),
                    value : 'average' + date.format( 'd' ),
                }
            ) );

            // peek( 'dayHeaders' )( dayHeaders );
            return [ { text : 'Sensor', value : 'SensorName' }, ...dayHeaders ];
        },
    },

    watch: {
    },

    methods : {

        currentWeekDates() {
            const iter = ( day, dates ) =>
                day >= 7 ? dates : iter( day + 1, [...dates, this.globalState.currentDate.day( day )] );

            return iter( 0, [] );
        },

        showToday() {
            this.globalState.setDate( dayjs() );
        },

        showPreviousDate() {
            this.globalState.changeDate( -7 );
        },

        showNextDate() {
            this.globalState.changeDate( 7 );
        },

        async showAccount() {
            const account = this.globalState.account;

            if ( ! account )
                return;

            this.accountTitle = account.location + ': ' + account.description;

            // Step 1: Get the devices for the account
            this.getAccountDevices( account )
                .catch( error => {
                    console.log( 'WARNING: could not get devices', error );
                    return [];
                } )
                // Step 2: Get the SensorCheckoutRecords for the account for this week
                .then( devices => this.getSensorCheckoutRecords( account, this.currentWeekDates() )
                                      .then( checkoutRecordMap => [ devices, checkoutRecordMap ] ) )
                .then( ( [ devices, checkoutRecordMap ] ) => {
                    // Step 3: Make blank table items for each device

                    const makeTableItem = ( serial, name ) => {
                        const tableItem = [...Array(7).keys()].reduce( ( acc, dow ) => {
                            acc[ `average${dow}` ] = '';
                            acc[ `tooltip${dow}` ] = '';

                            return acc;
                        }, { SensorName : name, name, serial, augmentedCheckoutRecords : [] } );

                        return tableItem;
                    }

                    const unsortedTableItems = Object.entries( checkoutRecordMap ).flatMap( recordsBySerial => {
                        const [ serial, recordsByLocalDate ] = recordsBySerial;

                        const records = Object.values( recordsByLocalDate );

                        if ( records.length > 0 )
                            return [ makeTableItem( serial, records[0].name ) ];

                        return [];
                    } );

                    const tableItemsBySerial = unsortedTableItems.reduce( ( acc, tableItem ) => {
                        acc[ tableItem.serial ] = tableItem;
                        return acc;
                    }, {} );

                    // Let's add any devices for which there is no record
                    devices.forEach( device => {
                        if ( ! tableItemsBySerial[ device.serial ] )
                            tableItemsBySerial[ device.serial ] = makeTableItem( device.serial, device.name );
                    } );

                    this.tableItems = Object.values( tableItemsBySerial ).sort( compareSensorsByName );

                    Object.entries( checkoutRecordMap ).forEach( ( [ serial, controlRecordsByLocalDate ] ) => {
                        serial; // lint
                        Object.entries( controlRecordsByLocalDate ).forEach( ( [ localDate, checkoutRecord ] ) => {
                             // peek( 'checkoutRecord ' )( checkoutRecord );
                            // Step 4: Compute the average for each day for each device
                            this.getAverageTemperature( localDate, checkoutRecord )
                                .then( result => {
                                    let tableItem = tableItemsBySerial[ result.checkoutRecord.serial ];
                                    if ( tableItem == null ) {
                                        console.log( `ERROR: no tableItem for ${result.checkoutRecord.serial}` );
                                        return;
                                    }

                                    const dow = dayjs( result.localDate ).format( 'd' );
                                    const checkoutType = result.checkoutRecord.checkoutType,
                                          notes = result.checkoutRecord.notes ? ` (${result.checkoutRecord.notes})` : '';
                                    let label;
                                    switch ( checkoutType ) {
                                        case this.checkoutType.repairs.value :
                                        case this.checkoutType.resting.value :
                                            label = checkoutType + notes;
                                            break;

                                        case this.checkoutType.delivery.value :
                                        case 'Repartición': // The old value for deliveries
                                            label = result.average + notes;
                                            break;

                                        // case this.checkoutType.extra.value :
                                        default :
                                            label = result.average + ' ' + checkoutType + notes;
                                            break;
                                    }

                                    tableItem[ `average${dow}` ] = label;
                                    tableItem[ `tooltip${dow}` ] = 'Salida: ' + formatCheckoutRecordDate( result.checkoutRecord, 'checkoutUnixtime' ) +
                                                                   ', Llegada: ' + formatCheckoutRecordDate( result.checkoutRecord, 'checkinUnixtime' );
                                    checkoutRecord.average = result.average;
                                    tableItem.augmentedCheckoutRecords.push( checkoutRecord );
                                } );
                        } );
                    } );
                } );
        },

        getAccountDevices( account ) {
            return pingAccount( this.globalState.accountDevicesCache, account );
        },

        downloadCsv() {
            if ( this.tableItems.length < 1 )
                return true;

            try {
                const account = this.globalState.account,
                      weekDates = this.currentWeekDates(),
                      filename = account.location + '-' +
                                 account.description + '-Promedios-' +
                                 weekDates[0].format( 'YYYY-MM-DD' ) + '.csv';

                const convertItem = checkoutRecord => [
                    account.location,
                    account.description,
                    checkoutRecord.name,
                    checkoutRecord.checkoutType,
                    checkoutRecord.notes,
                    checkoutRecord.average,
                    dayjs.unix( checkoutRecord.checkoutUnixtime ).format( 'YYYY-MM-DD HH:mm:ss' ),
                    dayjs.unix( checkoutRecord.checkinUnixtime ).format( 'YYYY-MM-DD HH:mm:ss' ),
                ];

                const convertItems = pipe(
                    chain( prop( 'augmentedCheckoutRecords' ) ),
                    sortWith([
                        compareSensorsByName,
                        ascend( prop( 'checkoutUnixtime' ) )
                    ]),
                    map( convertItem ),
                );
                const data = convertItems( this.tableItems );

                const fields = [ 'Canal', 'Localidad', 'Sensor', 'Tipo', 'Notas', 'Promedio', 'Salida', 'Llegada' ];
                const csv = Papa.unparse( { fields, data }, {
                    quotes : false,
                    quoteChar : '"',
                    escapeChar : '"',
                    delimiter : ',',
                    header : true,
                    newline : '\r\n',
                } );
                // utf-8 is not loaded properly by Excel
                // const uri = 'data:text/csv;charset=utf-8,' + '\uFEFF' + encodeURIComponent( csv );
                const uri = 'data:text/csv;base64,' + '77u/' + btoa( csv );

                const link = document.createElement( 'a' );
                link.id = 'csv-1';
                link.href = uri;

                document.body.appendChild( link );

                link.style.visibility = 'hidden';
                link.download = filename;

                link.click();

                setTimeout( () => document.body.removeChild( link ) );

                return true;
            }
            catch( error ) {
                console.log( 'Error preparing CSV download link', error );

                return false;
            }
        },

        ////////////////////////////////////////////////////////////////////////////////
        // Back end

        getAverageTemperature( localDate, checkoutRecord ) {
            const computeAverage = ( sensorDayReading ) => {
                if ( ! sensorDayReading )
                    return text( 'averageNotAvailable' );

                const readings = sensorDayReading.readings.filter( reading =>
                    checkoutRecord.checkoutUnixtime <= reading.unixtime && reading.unixtime <= checkoutRecord.checkinUnixtime );
                // peek( 'filtered readings' )( readings );

                if ( readings.length === 0 )
                    return text( 'averageNotAvailable' );

                const sum = readings.reduce( ( sum, reading ) => sum + reading.reading, 0 );

                return ( sum / readings.length ).toFixed( 1 ) + '°';
            };

            return this.backendGetSensorDayReading( checkoutRecord.serial, localDate )
                       .then( sensorDayReading => ({
                           localDate,
                           checkoutRecord,
                           average : computeAverage( sensorDayReading ),
                       }) );
            // return Promise.resolve( checkoutRecord.ddbCheckoutDate );
        },

        backendGetSensorDayReading( serial, localDate ) {
            const params = {
                query : getSensorDayReading,
                variables : { serial, localDate },
            };

            return API.graphql( params )
                      .then( result => result.data.getSensorDayReading );
        },

        /*
         * Return the checkout records for all sensors in the accout for the given dates.
         *
         * The result is an object like this:
         *
         * { serial : { `localDate` : checkoutRecord } }
         */
        getSensorCheckoutRecords( account, dates ) {
            const listPromises = dates.map( date => date.format( 'YYYY-MM-DD' ) )
                                      .map( localDate => this.backendListSensorCheckoutRecords( account, localDate ) );

            const toMap = ( map, checkoutRecord ) => {
                if ( ! map[ checkoutRecord.serial ] )
                    map[ checkoutRecord.serial ] = new Map();

                map[ checkoutRecord.serial ][ checkoutRecord.localDate ] = checkoutRecord;

                return map;
            };

            return Promise.all( listPromises )
                          .then( result => result.flatMap( x => x ) )
                          .then( checkoutRecords => checkoutRecords.reduce( toMap, {} ) );
        },

        backendListSensorCheckoutRecords( account, localDate ) {
            const params = {
                query : listSensorCheckoutRecordsByAccountByDate,
                variables : {
                    tndAccountLoginId : account.loginId,
                    localDate : { eq : localDate },
                    limit : 1000,
                },
            };

            return API.graphql( params )
                      .then( result => result.data.listSensorCheckoutRecordsByAccountByDate.items,
                             error => {
                                 console.log( `Error listing sensor checkout records for ${account.loginId} on ${localDate}`, error );
                                 return [];
                             } );
        },

        getLastSensorUnixTimes( account ) {
            if ( ! account ) {
                console.log( 'There is no account selected' );

                return Promise.resolve( [] );
            }

            const params = {
                query : listLastSensorUnixTimes,
                variables : {
                    limit : 1000,
                },
            };

            return API.graphql( params )
                      .then( result => result.data.listLastSensorUnixTimes.items )
                      .catch( error => {
                          console.log( 'Error calling listLastSensorUnixTimes(): ', error );
                                    return [];
                      } );
        },
    },
}
</script>
